/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cost_EstimateInputs */



/**
* | output |
* | --- |
* | "Cost Estimate" |
*
* @param {Cost_EstimateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cost_estimate = /** @type {((inputs?: Cost_EstimateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_EstimateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Estimation des coûts")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kostenvoranschlag")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preventivo dei costi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Смета расходов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estimación de costos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("成本估算")
	if (locale === "ja") return /** @type {LocalizedString} */ ("費用見積もり")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लागत का अनुमान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Estimativa de custos")
	return /** @type {LocalizedString} */ ("Cost Estimate")
});